import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { StylistPickerComponent } from '../components/stylist-picker/stylist-picker.component';
import { List } from 'immutable';
import { InventoryHistory } from '../models/product-inventory-history.model';
import { InventoryHistoryService } from '../services/product-inventory-history.service';

interface primeNgCol {
  field: string;
  header: string;
}

interface IRow {
  dateTime: string;
  productName: string;
  adjustment: number;
  action: string;
}

@Component({
  selector: 'smr-inventory-history',
  templateUrl: './inventory-history.page.html',
  styleUrls: ['./inventory-history.page.scss'],
})
export class InventoryHistoryPage implements OnInit {

  @ViewChild(StylistPickerComponent)

  public isLoading: boolean = true;

  public historyItems: List<InventoryHistory>;

  public stats: Array<IRow>;

  public rawData: Array<IRow>;

  public errorOccurredWhileLoadingHistories: boolean = false;

  public cols: primeNgCol[];

  constructor(
    private inventoryHistoryService: InventoryHistoryService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { 

    this.isLoading = true;
    this.historyItems = List([]);
    this.stats = [];
    this.cols = [
      { field: 'dateTime', header: 'Date' },
      { field: 'productName', header: 'Product' },
      { field: 'adjustment', header: 'Adjustment' },
      { field: 'action', header: 'Action' },
    ];


  }

  ngOnInit() {
    this.loadHistory();
  }

  public loadHistory() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingHistories = false;
    this.historyItems = List([]);

    this.inventoryHistoryService.loadInventoryHistories().subscribe({
      next: (historyItems) => {
        this.isLoading = false;
        this.historyItems = historyItems;
        this.mapPaginatorValue();
        this.changeDetectorRef.markForCheck();
      },
      error: (err) => {
        this.isLoading = false;
        this.errorOccurredWhileLoadingHistories = true;
        this.changeDetectorRef.markForCheck();
      },
    });
  }

  public mapPaginatorValue() {
    this.historyItems.forEach((historyItem) => {
      let dateTime = historyItem.getDatetime();
      let productName = historyItem.getProductName();
      let adjustment = historyItem.getAdjustment();
      let action = historyItem.getAction();

      this.stats.push({ dateTime, productName, adjustment, action });
    });
    this.stats = this.stats.sort((a, b) => {
      return new Date(a.dateTime) < new Date(b.dateTime) ? 1 : -1;
    });

    this.rawData = this.stats;
  }

  search(event) {
    const keyword = event.target.value.toLowerCase();
    this.stats = this.rawData.filter((stat) => {
      return new Date(stat.dateTime).toString().toLowerCase().includes(keyword) 
      || stat.productName.toLowerCase().includes(keyword)
      || stat.adjustment == parseInt(keyword)
      || stat.action.toLowerCase().includes(keyword)
    })
  }

}
